// extracted by mini-css-extract-plugin
module.exports = {"root":"_1XfKY","siteLayout":"_8n-4J","isContentFullWidth":"_3SKb8","isMobile":"_38ZEJ","mobileScreenBlocker":"PskZy","tenant":"_1HdP9"};